import { render, staticRenderFns } from "./IncomeStatementCompactComponent.vue?vue&type=template&id=4539057c&scoped=true"
import script from "./IncomeStatementCompactComponent.vue?vue&type=script&lang=js"
export * from "./IncomeStatementCompactComponent.vue?vue&type=script&lang=js"
import style0 from "./IncomeStatementCompactComponent.vue?vue&type=style&index=0&id=4539057c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4539057c",
  null
  
)

export default component.exports